import { useState } from "react";
import { navLinks } from "@/mocks/homeData";

type SiteHeaderProps = {
  onAction: (message: string) => void;
};

export default function SiteHeader({ onAction }: SiteHeaderProps) {
  const [open, setOpen] = useState(false);

  const handleDownload = () => {
    setOpen(false);
    onAction("完整版全记录下载已开始（演示）");
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-20 md:px-8">
        <a href="#top" className="group flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-black text-background-50 md:h-11 md:w-11 md:text-xl">
            瓜
          </span>
          <h1 className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
              超碰吃瓜
            </span>
            <span className="mt-1 font-label text-[10px] uppercase tracking-[0.22em] text-foreground-500 md:text-[11px]">
              TIMELINE ARCHIVE
            </span>
          </h1>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="页面导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleDownload}
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-download-2-line text-base"></i>
            </span>
            下载全记录
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </span>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100  hover:text-foreground-950"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            onClick={handleDownload}
            className="mt-2 w-full cursor-pointer rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            下载全记录
          </button>
        </div>
      )}
    </header>
  );
}